import type { RouteRecordName } from 'vue-router'

const PUBLIC_ROUTES = Object.freeze([
  'login',
  'redirect',
  'logout',
  'logout-redirect',
  'forgot-password',
  'password-set-loginId-token',
  'book-bookingId'
]) as readonly string[]

export const usePublicRoutes = () => {
  const isPublicRoute = (routeName: RouteRecordName | null | undefined) => {
    if (typeof routeName !== 'string') {
      return false
    }

    return PUBLIC_ROUTES.includes(routeName)
  }

  const isBookingRoute = (routeName: RouteRecordName | null | undefined) => {
    return routeName === 'book-bookingId'
  }

  return { PUBLIC_ROUTES, isPublicRoute, isBookingRoute }
}
